import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Grid } from "@material-ui/core";
import DataTable from "../../../../components/DataTable/DataTable";
import DataTableLoader from "../../../../components/ContentLoader/DataTableLoader";
import QueueService from "../../../../services/QueueService/QueueService";
import { useParams } from "react-router-dom"

function MonitoringDetails(props) {
    const { t } = useTranslation();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [customColumn, setCustomColumn] = useState([])
    const params = useParams();
    const paramsId = params.id;

    useEffect(() => {
        // const pf = localStorage.getItem('pf');
        // const logId = pf === 'rpa' ? `?operation_id=${paramsId}` : `?ipaas_operation_id=${paramsId}`
        setLoading(true);
        QueueService.getQueueActivityLog(`?operation_id=${paramsId}`)
            .then((response) => {
                if (Array.isArray(response?.data)) {
                    setData(response.data);
                } else {
                    setData([]);
                }
                setLoading(false);
            })
            .catch(() => {
                //err
            });
    }, [props.setQueueActivityLog, paramsId]);


    useEffect(() => {
        const column = [
            {
                name: "id",
                label: " ",
                options: {
                    filter: false,
                    sort: false,
                    customBodyRenderLite: (dataIndex, rowIndex) => {
                        if (data && data[dataIndex]) {
                            return <span>{dataIndex + 1}.</span>;
                        }
                    },
                },
            },
            {
                name: "level",
                label: "Log Level",
                options: { filter: true, sort: true },
            },
            {
                name: "ms",
                label: "Library & Action",
                options: {
                    filter: true, sort: true,
                    customBodyRenderLite: (dataIndex) => {
                        if (data && data[dataIndex] && data[dataIndex].defination) {
                            const def = data[dataIndex].defination.split('_')
                            return `${def[0]} - ${def[1]}`
                        }
                    }
                },
            },
            {
                name: "text",
                label: "Description",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRenderLite: (dataIndex) => {
                        if (data && data[dataIndex]) {
                            if (data[dataIndex].level === 'TRIGGER-PARAM') {
                                try {
                                    const jsonData = JSON.parse(data[dataIndex].text);
                                    // Format JSON object properly
                                    const formattedJson = JSON.stringify(jsonData, null, 2);
                                    return <pre>{formattedJson}</pre>
                                } catch (error) {
                                    return data[dataIndex].text
                                }
                            } else {
                                return data[dataIndex].text
                            }
                        }
                    }
                },
            },
            {
                name: "created_at",
                label: "Created At",
                options: {
                    filter: true, sort: true,
                    customBodyRenderLite: (dataIndex) => {
                        if (data && data[dataIndex]) {
                            return new Date(data[dataIndex]?.created_at).toLocaleString(t('CONTENT.CREDENTIAL-TAB.LOCALE'));
                        }
                    },
                },
            },

        ]
        setCustomColumn(column)
    }, [data, t])

    return (
        <>
            {loading ? <DataTableLoader /> :
                <Grid
                    item
                    sm={12}
                    className="listuser-container"
                    data-test="listautom-page"
                >
                    <DataTable
                        data-test="automlist-datatable"
                        customColumns={customColumn}

                        selectableRows="multiple"
                        data={data ? data : []}
                        title={t("CONTENT.AUTOMS-LIST.AUTOM-LIST")}
                        loading={loading}
                    />

                </Grid>
            }
        </>
    );
};


export default MonitoringDetails;
